export const Paginate = (data, currentPage, pageSize) => {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const paginated = data.slice(start, end);
    return paginated;
};
